/**
 * Event item plan enum.
 *
 * @type {{PREMIUM: string, FREE: string, BASIC: string}}
 */
export const EVENT_ITEM_PLAN = {
  FREE: 'FREE',
  BASIC: 'BASIC',
  PREMIUM: 'PREMIUM',
};

/**
 * Order of prioruty of each plan.
 *
 * @type {{PREMIUM: number, FREE: number, BASIC: number}}
 */
export const EVENT_ITEM_PLAN_PRIORITY = {
  [EVENT_ITEM_PLAN.FREE]: 0,
  [EVENT_ITEM_PLAN.BASIC]: 1,
  [EVENT_ITEM_PLAN.PREMIUM]: 2,
};

/**
 * Enum for event addon item types.
 *
 * @type {{WALDOFIED: string, MEMORY_BOOK: string, GROUP_VIDEO: string}}
 */
export const EVENT_ADDON_ITEM_TYPE = {
  GROUP_VIDEO: 'GROUP_VIDEO',
  MEMORY_BOOK: 'MEMORY_BOOK',
  WALDOFIED: 'WALDOFIED',
  /**
   * @deprecated Waldofied PRO has been deprecated in lieu of WALDOFIED_PHOTO_FINDER
   */
  WALDOFIED_PRO: 'WALDOFIED_PRO',
  /**
   * @deprecated WALDOFIED_PRO_PLUS has been deprecated in lieu of WALDOFIED_PHOTO_FINDER_PLUS
   */
  WALDOFIED_PRO_PLUS: 'WALDOFIED_PRO_PLUS',
  // PRO items:
  WALDOFIED_PHOTO_FINDER: 'WALDOFIED_PHOTO_FINDER',
  WALDOFIED_PHOTO_FINDER_PLUS: 'WALDOFIED_PHOTO_FINDER_PLUS',
  WALDOFIED_PHOTO_FINDER_PLUS_10K: 'WALDOFIED_PHOTO_FINDER_PLUS_10K',
  WALDOFIED_PHOTO_FINDER_PLUS_25K: 'WALDOFIED_PHOTO_FINDER_PLUS_25K',
  WALDOFIED_PHOTO_FINDER_PLUS_50K: 'WALDOFIED_PHOTO_FINDER_PLUS_50K',
};
